module.exports = __webpack_public_path__ + "media/images/Wall-Tiled-1-fb2749066a35c14c39f51694836f37a1.png";